// Module
var code = "<h2 id=\"defaulted-on-your-loans\">Defaulted on your Loans?</h2> <p>If your loan defaults, your balance becomes due in full immediately. Find out what options are available.</p> ";
// Exports
export default code;